import { render, staticRenderFns } from "./index.vue?vue&type=template&id=695ae548&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=695ae548&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695ae548",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\CRM\\Client2026\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('695ae548')) {
      api.createRecord('695ae548', component.options)
    } else {
      api.reload('695ae548', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=695ae548&scoped=true&", function () {
      api.rerender('695ae548', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cms/customers/followInfo/index.vue"
export default component.exports